const DEFAULT_LOCALE = 'en';
const DEFAULT_EMAIL_HOST = 'support.gandi.net';
function mapLocaleToEmail(locale) {
  return {
    en: 'en',
    de: 'en',
    fr: 'fr',
    es: 'es',
    ja: 'ja',
    'zh-hant': 'zh',
    'zh-hans': 'zh'
  }[locale] || DEFAULT_LOCALE;
}
function getSupportEmail(locale = DEFAULT_LOCALE) {
  return `support-${mapLocaleToEmail(locale)}@${DEFAULT_EMAIL_HOST}`;
}
export { getSupportEmail };